/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (renders "not available" vs "not available online"
 *              label based on product_status_id)
 *   extends:   Component (@glimmer/component)
 *   template:  not-available-label.hbs
 *   args:      @hideAddToChart, @product_status_id
 *   uses:      -
 *   siblings:  -
 *   tests:     glimmer-getters-test.js
 *
 * `hideLabel` picks the online-hidden variant when the product's status is
 * flagged in @hideAddToChart, else the generic not-available label.
 */
import Component from '@glimmer/component';

export default class NotAvailableLabelComponent extends Component {
  get hideLabel() {
    const { hideAddToChart, product_status_id } = this.args;

    if (hideAddToChart && product_status_id && hideAddToChart[product_status_id]) {
      return {
        text: 'not_available_online',
        class: 'not-online',
      };
    }

    return {
      text: 'not_available',
      class: '',
    };
  }
}
